import request from './request'

export const getShopReferrerList = (params) => {
  return request({
    url: '/admin/shop-referrers',
    method: 'get',
    params
  })
}

export const getShopReferrerDetail = (id) => {
  return request({
    url: `/admin/shop-referrers/${id}`,
    method: 'get'
  })
}

export const createShopReferrer = (data) => {
  return request({
    url: '/admin/shop-referrers',
    method: 'post',
    data
  })
}

export const updateShopReferrer = (id, data) => {
  return request({
    url: `/admin/shop-referrers/${id}`,
    method: 'put',
    data
  })
}

export const deleteShopReferrer = (id) => {
  return request({
    url: `/admin/shop-referrers/${id}`,
    method: 'delete'
  })
}
